import { CreateAxiosDefaults } from 'axios';

const { VITE_API_URL, VITE_TIMEOUT } = import.meta.env;

/**
 * Axios 인스턴스 기본 설정
 */
export const DEFAULT_AXIOS_CONFIG: CreateAxiosDefaults = {
  baseURL: VITE_API_URL || '',
  withCredentials: true,
  timeout: VITE_TIMEOUT ? parseInt(VITE_TIMEOUT) : 30000,
};
